import React, { useEffect, useState } from 'react';
import './StarLead.css';
import StarLeaderBoardTopInt from './StarLeaderBoardTopInt';
import StarRankingInt from './StarRankingInt';
import { GET, getQuery, makeApiCal } from '../../util';


function StarLeaderboardIntComp(props) {
  const [apiData, setApiData] = useState();
  const [data, setData] = useState();
  const [err, catchError] = useState(false);
  const [topData, setTopData] = useState();
  const [belowData, setBelowData] = useState();

  const getData = () => {
    const action = {
      method: GET,
      route: 'v1/campaign/detailPage',
      storeData: setApiData,
      catchError: catchError,
    };
    makeApiCal(action);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setData(apiData?.rankingYearPage);
    setTopData(apiData?.rankingYearPage?.teamRankings?.slice(0,3));
    setBelowData(apiData?.rankingYearPage?.teamRankings?.slice(3, apiData?.rankingYearPage?.teamRankings.length));
  }, [apiData])


  return (
  <div className='star-contt'> 
    <div className="starLeaderboardInt fadeIn">
      <div className="starLeaderboardInt__Body">
        <img className='star-img' src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/4.svg'></img>
        {topData ? <StarLeaderBoardTopInt data={topData} info={data?.info} /> : <></>}
        {belowData ? <StarRankingInt data={belowData} info={data?.info} /> : <></>}

      </div>
    </div>
    </div>
  );
}

export default StarLeaderboardIntComp;
